import { Booking } from "../../types";

interface Props {
  record?: Booking & {
    outbound_transaction_numbers?: string | string[];
  };
  label?: string;
  addLabel?: boolean;
}

const OutboundTransactionNumbers: React.FC<Props> = (props) => {
  const { record: booking } = props;

  if (!booking || !booking.outbound_transaction_numbers) {
    return <></>;
  }

  try {
    const outboundNumbers = booking.outbound_transaction_numbers;

    if (typeof outboundNumbers === "string" && outboundNumbers.includes("[")) {
      const parsedArray = JSON.parse(outboundNumbers);
      return <div>{parsedArray.join(", ")}</div>;
    } else if (Array.isArray(outboundNumbers)) {
      return <div>{outboundNumbers.join(", ")}</div>;
    } else {
      return <div>{outboundNumbers}</div>;
    }
  } catch (error) {
    return <div>{String(booking.outbound_transaction_numbers)}</div>;
  }
};

OutboundTransactionNumbers.defaultProps = {
  label: "Outbound Transaction Numbers",
  addLabel: true,
};

export default OutboundTransactionNumbers;
